"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  .st0 {\n    fill: #323e48;\n  }\n\n  .st1 {\n    fill: #00a7e1;\n  }\n\n  animation: ", " 3s linear infinite;\n  width: 200px;\n  max-width: 80vw;\n  margin: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: rotateY(0deg);\n  }\n\n  100% {\n    transform: rotateY(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var spinKeyframes = (0, _styledComponents.keyframes)(_templateObject());

var Wrapper = _styledComponents.default.div(_templateObject2(), spinKeyframes);

var HomebridgeLogoAnimation = function HomebridgeLogoAnimation(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("svg", {
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 237",
    style: {
      enableBackground: ' 0 0 248 237'
    }
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st0 top-left",
    points: "56.33,112.49 56.33,37.32 93.88,37.32 93.88,83.42 "
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st0 top-right",
    points: "161.46,83.42 161.46,37.32 199,37.32 199,112.49 "
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "st1 bottom",
    points: "199,132.44 127.64,76.04 56.33,132.38 56.33,210.02 93.88,210.02 93.88,144.7 127.63,117.68 161.46,144.7 161.46,210.02 199,210.02 "
  })));
};

HomebridgeLogoAnimation.propTypes = {
  className: _propTypes.default.string
};
HomebridgeLogoAnimation.defaultProps = {
  className: ''
};
var _default = HomebridgeLogoAnimation;
exports.default = _default;